export default "__VITE_ASSET__CNF0cLpN__"